import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import WorkRemoteBlog from "../blog/02WorkRemote/workremote"

const RemoteWork = () => (
    <Layout>
        <SEO title="Remote Work | Ryan Luu" />
        <WorkRemoteBlog />
    </Layout>
)

export default RemoteWork